'use client';

import { FC } from 'react';
import { ClickableDiv } from '../../../components/button';
import { IcoMoonIcon } from '../../../components/icons/icomoon';

export const CloseSidebarButton: FC<{
  onClick?: () => void;
}> = ({ onClick }) => {
  return (
    <ClickableDiv className="block p-5 xl:hidden" onClick={onClick}>
      <IcoMoonIcon
        className="text-text300 h-[14px] w-[14px]"
        iconName="close"
      />
    </ClickableDiv>
  );
};
